import React, { createContext, useMemo } from "react";
import useModalCreator from "./useModalCreator";
import Modal from "./Modal";

let ModalContext;
let { Provider } = (ModalContext = createContext());

ModalContext.displayName = 'ModalContext'

function ModalProvider({ children }) {
	let { show, showModal, onClose, modalConfiguration } = useModalCreator();

	const contextValue = useMemo(() => ({
		show,
		showModal,
		onClose,
		modalConfiguration
	}), [show, showModal, onClose, modalConfiguration]);

	return (
		<Provider value={contextValue}>
			<Modal
				modalConfiguration={modalConfiguration}
				show={show}
				onClose={onClose}
			/>
			{children}
		</Provider>
	);
};

export { ModalContext, ModalProvider };
